var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{attrs:{"gutter":30}},_vm._l((_vm.ladingCodes),function(ladingCode){return _c('a-col',{key:ladingCode.id,attrs:{"span":_vm.colSpan}},[_c('barcode',{attrs:{"value":ladingCode.ladingCode,"fontSize":35}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }